import { useDispatch, useSelector } from "react-redux";

import { BlogForm } from "./BlogForm";
import { CreateBlog } from "../../redux/blog";
import { ErrorBanner } from "../../components/banner";
import { Loading } from "../../components/loader";
import { Section } from "../../components/section";
import { useNavigate } from "react-router-dom";

export const BlogCreate = () => {
  const { error, loading } = useSelector((state) => state.blogs);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const onFormSubmit = (values) => {
    if (window.confirm(`Are you sure you want to add this article`)) {
      dispatch(CreateBlog(values));
    }

    if (!loading && !error) {
      setTimeout(() => {
        navigate("/press");
      }, 500);
    }
  };

  if (loading) {
    return <Loading />;
  }

  return (
    <Section>
      {error && <ErrorBanner text={error} />}
      <BlogForm onFormSubmit={onFormSubmit} />
    </Section>
  );
};
